









import { defineComponent } from '@vue/composition-api'
import { CollapseItem } from 'element-ui'

export default defineComponent({
  name: 'KisweCollapseItem',
  components: {
    'el-collapse-item': CollapseItem
  },
  props: {
    name: {
      type: String,
      required: false
    },
    title: {
      type: String as () => string|null,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
